import { useState } from 'react';
import type { UseForceOverrideStateResult } from './useForceOverrideState';
import type { OrthopulseOrderStep } from './step';

export interface UseOrthopulseStepResult {
    step: OrthopulseOrderStep;
    setStep: (step: OrthopulseOrderStep) => void;
    goToShipTo: () => void;
    cancelForceOverride: () => void;
}

// Cancelling from the preview step would otherwise strand the operator on a
// preview whose Send is about to disappear/fail - bounce back to ship-to.
export function useOrthopulseStep(
    forceOverride: UseForceOverrideStateResult
): UseOrthopulseStepResult {
    const [step, setStep] = useState<OrthopulseOrderStep>('ship-to');

    const cancelForceOverride = () => {
        forceOverride.reset();
        if (step === 'preview') setStep('ship-to');
    };

    return {
        step,
        setStep,
        goToShipTo: () => setStep('ship-to'),
        cancelForceOverride
    };
}
